import { render, staticRenderFns } from "./monthHealth.vue?vue&type=template&id=9a8d6f12&scoped=true&"
import script from "./monthHealth.vue?vue&type=script&lang=js&"
export * from "./monthHealth.vue?vue&type=script&lang=js&"
import style0 from "./monthHealth.vue?vue&type=style&index=0&id=9a8d6f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8d6f12",
  null
  
)

export default component.exports